import { SAVEIT_API_URL } from "../../config";
import { getAsync, postAsync, putAsync } from "./apiHelper";

const SaveitHTTApiService = {
  // 기존 신고서 조회 API
  checkNewFetch: () => {
    return getAsync(`${SAVEIT_API_URL}/hometax/checknewfetch`);
    /*
      { new_fetch: true } // 신규 데이터가 있으면 true, 없으면 false
     */
  },
  // Disabled: 기존 신고서 조회 API (calculateRefundable 과 함께 사용)
  getReportDetails: () => {
    return getAsync(`${SAVEIT_API_URL}/htt/report-details`);
  },
  // Disabled: 양도세 환급 가능 여부 계산 API (getReportDetails 와 함께 사용)
  calculateRefundable: () => {
    return getAsync(`${SAVEIT_API_URL}/htt/calculate-refundable`);
  },
  // 양도세 년도별 신고 목록 API (calculateRefundable + getReportDetails)
  getHTTList: () => {
    return getAsync(`${SAVEIT_API_URL}/htt/main`);
    /*
        [
          {
            "rett_report_detail_id": 1,
            "year": 2018, // 양도소득세_신고년도
            "status": 0, // None: 신고전, 1: 신청완료, 2: 계약완료, 3: 신고완료
            "passed_days": 0, // 신청 후 경과일

            "asset_address": "경기도 성남시 분******", // 주소
            "report_date": "20220404", // 신고일
            "national_tax": 100000, // 국세
            "local_tax": 10000, // 지방세
            "seller": "홍길동", // 양도인
            "buyer": "김**, 이**", // 양수인
            "period_available": true, // 환급_가능_여부: 환급 제외자가 아닌지 여부임
            "soduk": 0, // 수정양도소득금액
            "final_tax": 0, // 수정납부세액
            "refundable_tax": 0, // 환급예상금액
            "contract_date": "", // 계약일
            "contract_url": "", // 전자계약서 URL
            "contract_payment": "", // 계약금

            // 하드 코딩
            "agent_biz_name": "", // 세무대리인상호
            "agent_biz_no": "", // 세무대리인 사업자번호

            // TaxReturnHistory에서 얻어올 정보
            "tax_office_code": "", // 관할 세무서
            "tax_office_department": "", // 관할 세무서
            "tax_office_manager": "", // 담당자 이름
            "tax_office_manager_contact": "", // 담당자 전화번호
            "national_tax_report_url": "", // 국세 신고서 URL
            "local_tax_report_url": "", // 지방세 신고서 URL
          }
        ]
      */
  },
  // 양도세 환급 신청 API
  requestContract: (data) => {
    // data = { "rett_report_detail_id": 1 }, // 환급 신청 대상 report ID
    return postAsync(`${SAVEIT_API_URL}/htt/request`, data);
  },
  // 양도세 환급 신청 취소 API - 환급 신청 대상 request ID 사용
  cancelContract: (request_id) => {
    return postAsync(`${SAVEIT_API_URL}/htt/request/${request_id}/cancel`, {});
  },
  // 계약서 URL 조회 API
  getContractUrl: (requestId) => {
    return getAsync(`${SAVEIT_API_URL}/htt/request/${requestId}/contract`);
  },
  // 계약서 상세 화면 조회 API
  getContractDetails: (data) => {
    // data = { id: xxx } // 리포트 ID
    return getAsync(`${SAVEIT_API_URL}/htt/contract/`, { params: data });
    /*
      {
        "id": 1,
        "contract_date": "YYYYMMDD", // 계약일
        "contractor_name": "",  // 계약자 이름
        "contractor_birthday": "YYMMDD", // 계약자 생년월일
        "tax_agent": "", // 세무대리인상호
        "tax_agent_biz_no": "", // 세무대리인사업자번호
        "url": "", // 전자계약서 URL
      }
    */
  },
  // 양도세 업데이트 알림 신청 API
  // data = { "tit": true }
  noticeAgreement: (data) => {
    return putAsync(`${SAVEIT_API_URL}/user/notice-agreement`, data);
  },
};

export default SaveitHTTApiService;
